export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const SET_MESSAGE = 'SET_MESSAGE';
export const SET_ERROR = 'SET_ERROR';
export const REGISTER_USER = 'REGISTER_USER';
export const SET_NEW_USER = 'SET_NEW_USER';
export const CONFIRM_USER = 'CONFIRM_SIGN_UP';
export const REGISTER_USER_FAILED = 'REGISTER_USER_FAILED';
export const LOGOUT_USER = 'LOGOUT_USER';
export const FORGET_PASSWORD = 'FORGET_PASSWORD';
export const FORGET_PASSWORD_SUCCESS = 'FORGET_PASSWORD_SUCCESS';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const FORGET_PASSWORD_FAILED = 'FORGET_PASSWORD_FAILED';
export const CURRENT_AUTHENTICATED_USER = 'CURRENT_AUTHENTICATED_USER';
export const GET_CURRENT_SESSION = 'GET_SESSION';
export const NO_CURRENT_SESSION = 'NO_SESSION';
